import React from 'react';
import { useData } from '../../context/DataContext';

export const SubjectReadinessCards = () => {
  const { getScopedStudents } = useData();

  const scoped = getScopedStudents();
  const participated = scoped.filter(s => s.participated);
  const n = participated.length;

  const getSubjectStats = (sub) => {
    let sc = 0, sb = 0, sr = 0;
    participated.forEach(s => {
      const mastery = sub === 'eng' ? s.englishMastery : s.mathMastery;
      const target = s.registeredGrade;
      // const target = Math.min(7, s.registeredGrade);
      const gap = target - mastery;
      if (gap <= 0) sc++;
      else if (gap <= 2) sb++;
      else sr++;
    });

    const getPct = (v) => (n > 0 ? (v / n) * 100 : 0);

    return {
      c: sc,
      b: sb,
      r: sr,
      cPct: getPct(sc),
      bPct: getPct(sb),
      rPct: getPct(sr)
    };
  };

  const eng = getSubjectStats('eng');
  const math = getSubjectStats('math');

  return (
    <div className="mb-8 select-none">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Subject Readiness Distribution</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* English Card */}
        <div className="bg-white rounded-2xl p-5 shadow border-l-4" style={{ borderColor: '#2a6a4a' }}>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2 font-bold text-gray-800">
              <span>📗</span> English
            </div>
            <div className="text-right">
              <span className="text-xs text-gray-500 font-semibold">{n} students</span>
            </div>
          </div>
          {/* Stacked bar */}
          <div className="flex rounded-full overflow-hidden h-5 mb-3 w-full bg-gray-100">
            <div className="h-full transition-all" style={{ background: '#2a6a4a', width: `${eng.cPct}%` }}></div>
            <div className="h-full transition-all" style={{ background: '#d4870a', width: `${eng.bPct}%` }}></div>
            <div className="h-full transition-all" style={{ background: '#dc3545', width: `${eng.rPct}%` }}></div>
          </div>
          {/* Breakdown */}
          <div className="space-y-1 text-sm">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#2a6a4a' }}></span>
                Competent
              </span>
              <span className="font-bold" style={{ color: '#2a6a4a' }}>
                {eng.c} ({Math.round(eng.cPct)}%)
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#d4870a' }}></span>
                Bridge the Gap
              </span>
              <span className="font-bold" style={{ color: '#d4870a' }}>
                {eng.b} ({Math.round(eng.bPct)}%)
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#dc3545' }}></span>
                Remediation Need
              </span>
              <span className="font-bold" style={{ color: '#dc3545' }}>
                {eng.r} ({Math.round(eng.rPct)}%)
              </span>
            </div>
          </div>
        </div>

        {/* Mathematics Card */}
        <div className="bg-white rounded-2xl p-5 shadow border-l-4" style={{ borderColor: '#1e3a9a' }}>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2 font-bold text-gray-800">
              <span>📐</span> Mathematics
            </div>
            <div className="text-right">
              <span className="text-xs text-gray-500 font-semibold">{n} students</span>
            </div>
          </div>
          {/* Stacked bar */}
          <div className="flex rounded-full overflow-hidden h-5 mb-3 w-full bg-gray-100">
            <div className="h-full transition-all" style={{ background: '#2a6a4a', width: `${math.cPct}%` }}></div>
            <div className="h-full transition-all" style={{ background: '#d4870a', width: `${math.bPct}%` }}></div>
            <div className="h-full transition-all" style={{ background: '#dc3545', width: `${math.rPct}%` }}></div>
          </div>
          {/* Breakdown */}
          <div className="space-y-1 text-sm">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#2a6a4a' }}></span>
                Competent
              </span>
              <span className="font-bold" style={{ color: '#2a6a4a' }}>
                {math.c} ({Math.round(math.cPct)}%)
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#d4870a' }}></span>
                Bridge the Gap
              </span>
              <span className="font-bold" style={{ color: '#d4870a' }}>
                {math.b} ({Math.round(math.bPct)}%)
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm inline-block" style={{ background: '#dc3545' }}></span>
                Remediation Need
              </span>
              <span className="font-bold" style={{ color: '#dc3545' }}>
                {math.r} ({Math.round(math.rPct)}%)
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SubjectReadinessCards;
